// extracted by mini-css-extract-plugin
export default {"container":"productivityRate_container__Zsu4q"};